import { Component, OnInit, Input } from '@angular/core';
import { DeliveryCodeCheckType, DeliveryCodeCheckTypeStatusAux, Partner, PartnerPaymentMethods, PartnerPaymentStatus, PartnerProvinces, PartnerServices, vatOrFiscalRequiredValidator } from '../../models/partner.schema';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PartnerService } from '../../services/partner.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { User } from '../../models/user.schema';
import { FormGroupToObject } from '../../pipes/form-group-to-object.pipe';
import { AuthStatusService } from '../../services/auth-status.service';
import { UserService } from '../../services/user.service';
import { ServiceModel } from 'src/app/models/service.schems';
import { Service } from 'src/app/services/service.service';
import { ProvincesService } from 'src/app/services/provinces.service';
import { ProductCategoryService } from 'src/app/services/product-category.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { DatePipe } from '@angular/common';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { requiredArrayValidator } from 'src/app/helpers/validators/required-array.validator';
import { VAT_OR_CF_PATTERN } from './../../models/partner.schema';

@Component({
  selector: 'app-partner-form',
  templateUrl: './partner-form.component.html',
  styleUrls: ['./partner-form.component.scss']
})
export class PartnerFormComponent implements OnInit {
  @Input('profile') public profile: boolean = false;
  public readonly formValidationMsgs;
  public _partnerForm: any;
  public partner: Partner;
  private checkedVatCode: boolean;
  private checkedFiscalCode: boolean;
  public tmpBtnDisabled: boolean;

  private checkedPassword1: boolean;
  private checkedPassword2: boolean;
  showExtraKmInput: boolean[] = [];
  showPricePerItem: boolean[] = [];
  showSalesTypeLabel: boolean[] = [];
  showCorporateServiceLabel: boolean[] = [];
  public sendSms: boolean = false;
  public groups: string[];
  public services: ServiceModel[] = [];
  public partnerId: string|number = '';
  provinces: any[] = [];
  productCategories: any[] = [];
  previewUrl: string|SafeUrl;
  deliveryCodeCheckTypeEnum = DeliveryCodeCheckType;
  deliveryCodeCheckTypeStatusAux = DeliveryCodeCheckTypeStatusAux;
  vatTimeout: any;
  vatStatus: 'idle' | 'checking' | 'valid' | 'invalid' | 'serviceDown' = 'idle';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _snackBar: MatSnackBar,
    private partnerService: PartnerService,
    private userService: UserService,
    private authStatusService: AuthStatusService,
    private service: Service,
    private provincesService: ProvincesService,
    private productCategoryService: ProductCategoryService,
    private spinnerService: SpinnerService,
    private datePipe: DatePipe,
    private commanUsesService: CommanUsesService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder
  ) {
    this.formValidationMsgs = Partner.validationMessages;
    try {
      this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    }
    catch {
      this.groups = [];
    }
  }

  async ngOnInit() {
    try {
      this.spinnerService.show();
      const services = await this.service.getAllServicess();
      this.services = services.services;
      this.productCategories = await this.productCategoryService.getAllProductCategories();
      if(this.groups.includes('admin') || this.groups.includes('operation') || this.groups.includes('teamleader')){
        this.provinces = await this.provincesService.getAllProvinces();
      }
      await this.initialize();
      this._partnerForm.get('vatCode')?.valueChanges.subscribe(() => {
        this.vatStatus = 'idle';
      });

      this._partnerForm.get('sdiCode')?.valueChanges.subscribe(() => {
        this._partnerForm.get('certifiedEmail')?.updateValueAndValidity({
          onlySelf: true,
          emitEvent: false,
        });
      });

      this._partnerForm.get('certifiedEmail')?.valueChanges.subscribe(() => {
        this._partnerForm.get('sdiCode')?.updateValueAndValidity({
          onlySelf: true,
          emitEvent: false,
        });
      });
      this.spinnerService.hide();
    }
    catch(error) { 
      console.log("error", error);
      this.showSnackBar("Something Went Wrong On This Page");
    }
  }

  async initialize() {
    this._partnerForm = new FormGroup(Partner.validation(this.profile));
    const partnerId = this.profile ?
      (await this.partnerService.getOne(this.authStatusService.getExtra()['id'])).id.toString() :
      this.route.snapshot.paramMap.get('id');
    this.partnerId = partnerId;
    if (partnerId) {
      try {
        this.partner = await this.partnerService.getOne(partnerId);
      }
      catch {
        this.router.navigateByUrl("/404", { skipLocationChange: true });
      }
    }
    if (!this.partner) {
      this.partner = new Partner();
      this.partner.user = this.route.snapshot.paramMap.get('userId') ?
        await this.userService.getOne(this.route.snapshot.paramMap.get('userId')) :
        new User();
    }
    if(this.partnerId && this.partner) this.patch();
    if(this.partnerId && this.partner.partnerServices.length > 0){
      this.patchPartnerServices();
    }
    if(this.partnerId && this.partner?.partnerProvinces.length > 0){
      this.patchPartnerProvinces();
    }
    // this.setCustomValidators();
    this._partnerForm.setValidators(vatOrFiscalRequiredValidator);
    this._partnerForm.updateValueAndValidity();
    if (this.profile)
      this.setProfileValidators();

    this._partnerForm.get('isMultiplePickUpAddress')?.valueChanges.subscribe(value => {
      if (value) {
        if (this.pickupAddresses.length === 0) {
          this.addPickupAddress();
        }
      } else {
        this.pickupAddresses.clear();
      }
    });

  }

  setCustomValidators() {
    this._partnerForm.controls.fiscalCode.valueChanges.subscribe((next: any) => {
      if (!this.checkedFiscalCode) {
        this.checkedFiscalCode = true;
        this._partnerForm.controls.vatCode.updateValueAndValidity();
      }
      else
        this.checkedFiscalCode = false;
    });

    this._partnerForm.controls.vatCode.valueChanges.subscribe((next: any) => {
      if (!this.checkedVatCode) {
        this.checkedVatCode = true;
        this._partnerForm.controls.fiscalCode.updateValueAndValidity();
      }
      else
        this.checkedVatCode = false;
    });
  }

  patch() {
    [
      'businessName', 
      'vatCode', 
      'fiscalCode', 
      'phone', 
      'address', 
      'notes', 
      'longitude', 
      'latitude', 
      'sendSms', 
      'kmIncluded', 
      'receiveWhatsappMsg', 
      'receiveEmailMsg', 
      'extraOutSideCityKmPrice', 
      'billingAccess', 
      'billingEmail', 
      'agency',
      'partnerPaymentStatus',
      'partnerPaymentMethod',
      'bankAccount',
      'bankAccountName',
      'sdiCode',
      'checkExpertIndentity',
      'deliveryCodeCheck',
      'deliveryCodeCheckType',
      'partnerHasWarehouse',
      'partnerShopUrl',
      'isMultiplePickUpAddress',
      'wooCommerceApiKey',
      'certifiedEmail',
      'activityReminder',
    ].forEach(param => {
      this._partnerForm.controls[param].setValue(this.partner[param]);
    });
    ['surname', 'name', 'email'].forEach(param => {
      this._partnerForm.controls.user.controls[param].setValue(this.partner.user[param]);
    });
    if(this.partner?.partnerSoldProductCategories?.length > 0){
      this._partnerForm.patchValue({
        partnerSoldProductCategories: this.partner?.partnerSoldProductCategories.map((data) => {
          return data.productCategory.id
        })
      });
    }

    if (this.partner?.startContractDate || this.partner?.endContractDate) {
      this._partnerForm.get('contractValidity')?.patchValue({
        startContractDate: this.partner.startContractDate ? new Date(this.partner.startContractDate) : '',
        endContractDate: this.partner.endContractDate ? new Date(this.partner.endContractDate) : '',
      });
    }

    if(this.partner?.saleImage) {
      this.previewUrl = this.partner.saleImage || null;
    }

    if(this.partner.isMultiplePickUpAddress) {
      this.pickupAddresses.clear();
      this.partner.pickupAddresses.forEach(address => {
        this.pickupAddresses.push(this.fb.control(address, Validators.required)); 
      });
    }

    /*
    this._partnerForm.patchValue({
      hideCustomerServices: this.normalizeHideCustomerServices(
        this.partner?.hideCustomerServices
      ),
    });
    */
  }

  private normalizeHideCustomerServices(value: any): string[] {
    if (Array.isArray(value)) {
      return value;
    }

    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);

        if (Array.isArray(parsed)) {
          return parsed;
        }

        return value ? [value] : [];
      } catch {
        return value ? [value] : [];
      }
    }

    return [];
  }

  patchPartnerServices(){
    const control = <FormArray>this._partnerForm.get('partnerServices');
    control.clear();
    if (!this.partner.partnerServices || Array.isArray(this.partner.partnerServices) && this.partner.partnerServices.length == 0){
      this.partner.partnerServices = [new PartnerServices()];
    }
    this.partner.partnerServices.forEach((f, index) => {
      control.push(this.patchValues(f, index));
    });
  }

  patchValues(partnerServices: PartnerServices, index: number) {
    // this.showExtraKmInput[index] = partnerServices?.service?.pricingModel.toLowerCase() === 'fixedprice';
    this.showExtraKmInput[index] = (partnerServices?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || partnerServices?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL || partnerServices?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL);
    this.showSalesTypeLabel[index] = partnerServices?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL;
    this.showCorporateServiceLabel[index] = partnerServices?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL;
    this.showPricePerItem[index] = partnerServices?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL;
    let serviceForm = Partner.serviceFormGroup();
    serviceForm.controls.service.setValue(
      { 
        id: partnerServices?.service?.id, 
        price: partnerServices?.price,
        extraKmPrice: partnerServices?.extraKmPrice, 
        pricePerItem: partnerServices?.pricePerItem, 
        // extraOutSideCityKmPrice: partnerServices?.extraOutSideCityKmPrice
      }
    );
        
    return serviceForm;
  }

  patchPartnerProvinces(){
    const control = <FormArray>this._partnerForm.get('partnerProvinces');
    control.clear();
    if (!this.partner.partnerProvinces || Array.isArray(this.partner.partnerProvinces) && this.partner.partnerProvinces.length == 0){
      this.partner.partnerProvinces = [new PartnerProvinces()];
    }
    this.partner.partnerProvinces.forEach((f, index) => {
      control.push(this.patchPartnerProvinceValues(f, index));
    });
  }

  patchPartnerProvinceValues(partnerProvinces: PartnerProvinces, index: number) {
    let provinceForm = Partner.provinceFormGroup();
    provinceForm.controls.province.setValue(
      { 
        id: partnerProvinces?.province?.id, 
      }
    );
        
    return provinceForm;
  }

  setProfileValidators() {
    this.checkedPassword1 = false;
    this.checkedPassword2 = false;

    this._partnerForm.controls.user.controls.password1.valueChanges.subscribe((next: any) => {
      if (!this.checkedPassword1) {
        this.checkedPassword1 = true;
        this._partnerForm.controls.user.controls.password2.updateValueAndValidity();
      }
      else {
        this.checkedPassword1 = false;
        this.checkedPassword2 = false;
      }
    });

    this._partnerForm.controls.user.controls.password2.valueChanges.subscribe((next: any) => {
      if (!this.checkedPassword2) {
        this.checkedPassword2 = true;
        this._partnerForm.controls.user.controls.password1.updateValueAndValidity();
      }
      else {
        this.checkedPassword1 = false;
        this.checkedPassword2 = false;
      }
    });
  }

  get partnerSoldProductCategories(): FormArray {
    return this._partnerForm.get('partnerSoldProductCategories') as FormArray;
  }

  onSubmit() {
    try {
      this.tmpBtnDisabled = true;
      let partner: any = (new FormGroupToObject()).transform(this._partnerForm);
  
      if (partner.contractValidity) {
        const { startContractDate, endContractDate } = partner.contractValidity;

        partner.startContractDate = startContractDate
          ? this.datePipe.transform(startContractDate, 'yyyy-MM-dd')
          : null;

        partner.endContractDate = endContractDate
          ? this.datePipe.transform(endContractDate, 'yyyy-MM-dd')
          : null;

        delete partner.contractValidity;
      }
  
      const selectedSoldProductCategories = this.partnerSoldProductCategories.value.map((id: number) => {
        const soldProductCategory = this.productCategories.find(p => p.id === id);
        return { productCategory: { id } };
      });
      partner.partnerSoldProductCategories = selectedSoldProductCategories;
      if(this.groups.includes('partner')){
        delete partner?.partnerSoldProductCategories;
        delete partner?.partnerProvinces
        delete partner?.partnerServices
      }
      if(this.groups.includes('admin') || this.groups.includes('operation')){
        if(partner?.partnerProvinces[0]?.province?.id === null || partner?.partnerProvinces[0]?.province?.id === undefined){
          delete partner.partnerProvinces;
        }
        if(partner?.partnerServices[0]?.service?.id === null || partner?.partnerServices[0]?.service?.id === undefined){
          delete partner.partnerServices;
        }
        if(partner?.partnerSoldProductCategories[0]?.productCategory?.id === null || partner?.partnerSoldProductCategories[0]?.productCategory?.id === undefined){
          delete partner.partnerSoldProductCategories;
        }
      }
  
      /* Partner can not do anything more
      if(this.groups.includes('partner')){
        if([PartnerPaymentMethods.bankTransfer, PartnerPaymentMethods.directDebitMandate].includes(partner.partnerPaymentMethod)) {
          partner.partnerPaymentStatus = null;
        }
      }
      */
      // console.log("partner", partner)
      // return false;
      let promiseResult: any;
      let createType: boolean = true;
      if (this.profile &&
        this._partnerForm.controls.user.value.password1 &&
        this._partnerForm.controls.user.value.password1 === this._partnerForm.controls.user.value.password2
      )
        partner['user']['password'] = this._partnerForm.controls.user.value.password1;
      if (this.partner['id']) {
        partner['user']['id'] = this.partner.user.id;
        if(this.profile){
          delete partner['partnerServices'];
          promiseResult = this.partnerService.updateMe(partner)
        } else {
          promiseResult = this.partnerService.update(this.partner['id'], partner);
        }
        createType = false;
        // promiseResult = this.profile ?
        //   this.partnerService.updateMe(partner) :
        //   this.partnerService.update(this.partner['id'], partner);
      }
      else {
        if (this.partner.user.id)
          partner['user']['id'] = this.partner.user.id;
        promiseResult = this.partnerService.create(partner);
      }
      promiseResult.then((data: Partner) => {
        this.partner = data;
        const message: string = `Partner ${createType ? "creato" : "aggiornato"} con successo`;
        this._snackBar.open(message, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        }).afterDismissed().subscribe(result => {
          this.authStatusService.isAuthenticated().then(valid => {
            if (!valid)
              this.router.navigate(['/']);
          });
          if (createType) {
            if (this.route.snapshot.paramMap.get('userId')){
              this.router.navigate(['/utenti']);
            } else{
              this.router.navigate(['/partner', this.partner.id, 'edit']);
            }
          }
        });
        this.patch();
        this.tmpBtnDisabled = false;
      }).catch(error => {
        this._snackBar.open(`Errore ${createType ? "nella creazione" : "nell'aggiornamento"} del partner`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
        this.tmpBtnDisabled = false;
        console.log(error);
      });
    } catch (error) {
      this._snackBar.open(`Errore Something went wrong`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
    }
  }

  getAddress(place: any) {
    if (!this._partnerForm) return;
    this._partnerForm.controls.address.touched = true;
    this._partnerForm.controls.address.setValue(place.formatted_address || place.name || '');
    this._partnerForm.controls.latitude.setValue(place.geometry?.location?.lat() || '');
    this._partnerForm.controls.longitude.setValue(place.geometry?.location?.lng() || '');
  }

  directions(event: Event) {
    event.preventDefault();
    window.open(`https://www.google.com/maps/dir//${this._partnerForm.controls.address.value}`, '_blank');
  }

  /*
  onDuplicate(){
    console.log('funcion clicked')
    this.tmpBtnDisabled = true;
    let partner = (new FormGroupToObject()).transform(this._partnerForm);
    let promiseResult: any;
    promiseResult = this.partnerService.create(partner);
    promiseResult.then(async(data: Partner) => {
      this.partner = data;
      const message: string = `Partner duplicata con successo. Nuovo id creato : '${this.partner.id}'`;
      this._snackBar.open(message, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      }).afterDismissed().subscribe(result => {
        this.authStatusService.isAuthenticated().then(valid => {
          if (!valid)
            this.router.navigate(['/']);
        });
        this.router.navigate(['/partner', this.partner.id, 'edit']);
        this.patch();
        this.tmpBtnDisabled = false;
      })
    }).catch((err: any) => {
      this._snackBar.open(`Errore Something went wrong`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
      this.tmpBtnDisabled = false;
      console.log(err);
    });
  }
  */

  addService() {
    const control = <FormArray>this._partnerForm.get('partnerServices');
    control.push(Partner.serviceFormGroup());
  }

  addProvince() {
    const control = <FormArray>this._partnerForm.get('partnerProvinces');
    control.push(Partner.provinceFormGroup());
  }

  isOptionDisabled(item: any): boolean {
    let hasEmptyId = false;
    for (const services of this._partnerForm.value.partnerServices) {
      if (services.service.id === item.id) {
        hasEmptyId = true;
      }
    }
    return hasEmptyId; // assuming your item has a 'disabled' property
  }

  isProvinceOptionDisabled(item: any): boolean {
    let hasEmptyId = false;
    for (const provinces of this._partnerForm.value.partnerProvinces) {
      if (provinces.province.id === item.id) {
        hasEmptyId = true;
      }
    }
    return hasEmptyId;
  }

  removeService(index: number) {
    const control = <FormArray>this._partnerForm.get('partnerServices');
    if (control.length === 1) {
      return;
    }
    control.removeAt(index);
    this.showExtraKmInput.splice(index, 1);
    this.showSalesTypeLabel.splice(index, 1);
    this.showCorporateServiceLabel.splice(index, 1);
  }

  removeProvince(index: number) {
    const control = <FormArray>this._partnerForm.get('partnerProvinces');
    if (control.length === 1) {
      return;
    }
    control.removeAt(index);
  }


  handleServiceChange(event: any, index: number) {
    const selectedService = this.services.find(service => service.id == event);
    // this.showExtraKmInput[index] = selectedService.pricingModel.toLowerCase() === 'fixedprice';
    this.showExtraKmInput[index] = (selectedService.pricingModel.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || selectedService.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL || selectedService.pricingModel.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL);
    this.showPricePerItem[index] = selectedService.pricingModel.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL;
    this.showSalesTypeLabel[index] = selectedService.pricingModel.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL;
    this.showCorporateServiceLabel[index] = selectedService.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL;
  }

  async onImageSelected(event: any) {
    try {
      if(!this.partner.id) {
        this.commanUsesService.showSnackBar('Partner is not created yet.');
        return;
      }

      const file = event.target.files[0];
      if (!file) return;

      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      if (!allowedTypes.includes(file.type)) {
        this.commanUsesService.showSnackBar('Formato file non valido. Carica solo JPG, JPEG o PNG.');
        event.target.value = '';
        return;
      }

      this.tmpBtnDisabled = true;

      const blobUrl = URL.createObjectURL(file);
      this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl);

      const formData = new FormData();
      formData.append('image', file);
      formData.append('id', String(this.partner?.id));

      const promiseResult: Partner = await this.partnerService.uploadSaleImage(formData);
      if(promiseResult?.id && promiseResult?.saleImage) {
        this.tmpBtnDisabled = false;
        this.commanUsesService.showSnackBar('IMMAGINE_DI_VENDITA_CARICATA_CON_SUCCESSO');
      } else {
        this.tmpBtnDisabled = false;
        this.commanUsesService.showSnackBar('SOMETHING_WENT_WRONG');
      }
    } catch (error) {
      this.tmpBtnDisabled = false;
      const errorMsg = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errorMsg);
    }
  }

  async removeImage() {
    try {
      if(!this.partner.id) {
        this.commanUsesService.showSnackBar('Partner is not created yet.');
      } 

      if(!confirm(`Sei sicuro? L'immagine in saldo verrà rimossa.`)) return;

      this.tmpBtnDisabled = true;
      const promiseResult: Partner = await this.partnerService.removeSaleImage(this.partner.id);
      if(promiseResult.id && !promiseResult.saleImage) {
        this.previewUrl = '';
        this.tmpBtnDisabled = false;
        this.commanUsesService.showSnackBar(`L'immagine in saldo è stata rimossa con successo.`);
      } else {
        this.tmpBtnDisabled = false;
        this.commanUsesService.showSnackBar(`SOMETHING_WENT_WRONG`);
      }
    } catch (error) {
      this.tmpBtnDisabled = false;
      const errMsg: string = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errMsg);
    }
  }

  async showSnackBar(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }

  handleDeliveryCodeCheck(event: any) {
    this.updateValidator(event.target.checked);
  }

  updateValidator(status: boolean) {
    if (status) {
      this._partnerForm.get('deliveryCodeCheckType').setValidators(Validators.required);
    } else {
      this._partnerForm.get('deliveryCodeCheckType').setValue('');
      this._partnerForm.get('deliveryCodeCheckType').clearValidators();
    }
    this._partnerForm.get('deliveryCodeCheckType').updateValueAndValidity();
  }

  get pickupAddresses(): FormArray {
    return this._partnerForm.get('pickupAddresses') as FormArray;
  }

  addPickupAddress() {
    this.pickupAddresses.push(
      new FormControl('', Validators.required)
    );
  }

  getPickupAddress(place: any, index: number) {
    if (!this.pickupAddresses) return;
    const control = this.pickupAddresses.at(index);
    control.setValue(place.formatted_address || place.name || '');
  }

  removePickupAddress(index: number) {
    this.pickupAddresses.removeAt(index);
  }

  getErrorMessages(): string[] {
    const errors: string[] = [];

    if (!this._partnerForm) return errors;

    const scan = (control: any, key?: string) => {

      if (!control) return;

      if (control instanceof FormGroup) {
        Object.keys(control.controls).forEach(k => {
          scan(control.controls[k], k);
        });
        return;
      }

      if (control instanceof FormArray) {
        control.controls.forEach((c: any) => scan(c, key));
        return;
      }

      if (control.errors && key && !errors.includes(key)) {
        errors.push(key);
      }
    };

    scan(this._partnerForm);

    return errors;
  }

  translateErrorMessage(error: string): string {

    const messages: { [key: string]: string } = {

      businessName: 'NOME',
      email: 'EMAIL',
      vatCode: 'PARTITA IVA',
      fiscalCode: 'CODICE FISCALE',
      address: 'INDIRIZZO',
      phone: 'TELEFONO',

      surname: 'COGNOME REFERENTE',
      name: 'NOME REFERENTE',

      agency: 'AZIENDA',

      partnerProvinces: 'PROVINCIA',
      partnerServices: 'SERVIZIO',

      price: 'PREZZO SERVIZIO',
      extraKmPrice: 'PREZZO EXTRA KM',

      kmIncluded: 'KM INCLUSI',
      extraOutSideCityKmPrice: 'PREZZO FUORI CITTÀ',

      partnerSoldProductCategories: 'CATEGORIE PRODOTTI',

      partnerPaymentMethod: 'METODO DI PAGAMENTO',
      partnerPaymentStatus: 'STATO PAGAMENTO',

      bankAccount: 'CONTO BANCARIO',
      bankAccountName: 'NOME CONTO BANCARIO',
      sdiCode: 'CODICE SDI',

      billingEmail: 'EMAIL FATTURAZIONE',

      contractValidity: 'VALIDITÀ CONTRATTO',

      deliveryCodeCheckType: 'TIPO CODICE CONSEGNA',

      pickupAddresses: 'INDIRIZZO DI RITIRO',

      partnerShopUrl: 'URL NEGOZIO',
      hideCustomerServices: 'Seleziona almeno un servizio',
      certifiedEmail: 'EMAIL CERTIFICATA PEC'
    };

    return messages[error] || error;
  }

  onVatBlur() {
    const vatControl = this._partnerForm.get('vatCode');

    if (!vatControl || !vatControl.value) {
      this.vatStatus = 'idle';
      return;
    }

    const value = vatControl.value.toUpperCase().trim();

    if (vatControl.hasError('pattern')) {
      this.vatStatus = 'invalid';
      return;
    }

    // Only VAT (11 digits) goes to backend
    if (!/^\d{11}$/.test(value)) {
      this.clearVatErrors(vatControl);
      this.vatStatus = 'valid'; // CF assumed valid if pattern passes
      return;
    }

    clearTimeout(this.vatTimeout);

    this.vatStatus = 'checking';

    this.vatTimeout = setTimeout(() => {
      const country = 'IT';

      this.partnerService.validateVat(country, value)
        .then((res: any) => {

          this.removeError(vatControl, 'vatServiceDown');

          if (!res.valid && !VAT_OR_CF_PATTERN.test(value)) {
            vatControl.setErrors({
              ...vatControl.errors,
              invalidVat: true
            });
            this.vatStatus = 'invalid';
          } else {
            this.removeError(vatControl, 'invalidVat');
            this.vatStatus = 'valid';
          }
        })
        .catch(() => {
          vatControl.setErrors({
            ...vatControl.errors,
            vatServiceDown: true
          });
          this.vatStatus = 'serviceDown';
        });

    }, 400);
  }

  private removeError(control: any, errorKey: string) {
    if (control.hasError(errorKey)) {
      const errors = { ...control.errors };
      delete errors[errorKey];
      control.setErrors(Object.keys(errors).length ? errors : null);
    }
  }

  private clearVatErrors(control: any) {
    this.removeError(control, 'invalidVat');
    this.removeError(control, 'vatServiceDown');
  }

  isVatChecking(): boolean {
    return this.vatStatus === 'checking';
  }

  async generateWooCommerceKey() {
    try {
      const apiKey = `ck_${this.generateSecureToken(24)}`;
      this._partnerForm.controls.wooCommerceApiKey.setValue(apiKey);
    } catch (error) {
      const errorMessage =
        error?.error?.message || error?.message || 'Something went wrong';

      this.commanUsesService.showSnackBar(errorMessage);
    }
  }

  generateSecureToken(length: number = 48): string {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);

    return Array.from(array)
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('');
  }

  copyWooKey() {
    const value = this._partnerForm.get('wooCommerceApiKey')?.value;

    if (!value) {
      return;
    }

    navigator.clipboard.writeText(value);

    this.commanUsesService.showSnackBar('API key copied');
  }

}
